import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { CardTitle } from '@/components/ui/card';
    import { columns } from '@/tables/columns/holiday-pay-obligations';
    import { computed } from 'vue';
    import { Head } from '@inertiajs/vue3';
    import { usePage } from '@inertiajs/vue3';
    import { usePermissions } from '@/composables/usePermissions';
    import { useQuery } from '@tanstack/vue-query';
    import AppLayout from '@/layouts/AppLayout.vue';
    import axios from 'axios';
    import DataTable from '@/components/datatable/DataTable.vue';
    import PageCard from '@/components/PageCard.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';
    import type { BreadcrumbItem } from '@/types';
    import type { SharedData } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'HolidayPayObligations',
  setup(__props) {

    const { hasPermission } = usePermissions();
    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'dashboards.payroll',
        },
        {
            title: 'holiday-pay-obligations.page_header',
        },
    ];

    const { isPending, isFetching, isError, data, error, refetch } = useQuery({
        queryKey: [QueryKey.HOLIDAY_PAY_OBLIGATIONS, selectedCompanyId],
        queryFn: getHolidayPayObligations,
    });

    async function getHolidayPayObligations() {
        const { data } = await axios.get(
            route('v2.salary.holiday-pay-obligations.table', {
                companyId: selectedCompanyId.value,
            }),
        );
        return data.data;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), {
      title: _ctx.$t('holiday-pay-obligations.page_header')
    }, null, 8, ["title"]),
    _createVNode(AppLayout, {
      breadcrumbs: breadcrumbs,
      "require-selected-company": ""
    }, {
      default: _withCtx(() => [
        _createVNode(PageCard, null, {
          default: _withCtx(() => [
            _createVNode(DataTable, {
              "table-key": _unref(QueryKey).HOLIDAY_PAY_OBLIGATIONS,
              columns: _unref(columns),
              data: _unref(data),
              loading: _unref(isPending),
              "default-column-visibility": {
                    id: false,
                    file_upload: _unref(hasPermission)(_unref(Permission).HOLIDAY_PAY_OBLIGATIONS_UPDATE),
                },
              "default-sorting": [
                    {
                        id: 'year',
                        desc: true,
                    },
                    {
                        id: 'month',
                        desc: true,
                    },
                ]
            }, {
              title: _withCtx(() => [
                _createVNode(_unref(CardTitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('holiday-pay-obligations.page_header')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["table-key", "columns", "data", "loading", "default-column-visibility"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})